<div class="content-drag-scroll" [style.width.px]="isBrowser ? blockWidth : 'auto'">
  <div class="pane-header" [class.mobile]="deviceService.isMobile()">
  <app-title *ngIf="title && !isLibrary" [params]="title" [class.mobile]="!isDragScrollEnabled"></app-title>
  <app-library-title *ngIf="isLibrary" [title]="libraryTitle" [class.with-sorting]="_pane.show_sorting">
    <ng-container side>
      <span class="subtitle">{{ libraryTitle?.subtitle | translate }}</span>
    </ng-container>
  </app-library-title>
  <app-library-sorting *ngIf="_pane.show_sorting" [class.no-link]="libraryTitle?.see_all_link === 'no-link'" [class.with-more]="libraryTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
  </div>
  <div *ngIf="items.length === 0" class="no-items">
    <span class="explanation">Пока здесь пусто.
      <a [routerLink]="urlRoute" class="explanation explanation--link">Создать</a>
    </span>
  </div>

  <ng-template [ngIf]="items.length > 0">
    <ng-template [ngIf]="isDragScrollEnabled && isBrowser" [ngIfElse]="responsiveScroll">
      <div class="carousel">
        <ng-template [ngIf]="items.length > 4">
          <div class="right-btn" (click)="moveRight()">
            <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
          </div>

          <div class="left-btn" (click)="moveLeft()">
            <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
          </div>
        </ng-template>

        <cdk-virtual-scroll-viewport #scroller
                                     [itemSize]="cardSizeTable.width"
                                     [style.height.px]="height()"
                                     class="scroll-viewport"
                                     orientation="horizontal">
          <div *cdkVirtualFor="let column of chunk(items, chunkNumber); let idx = index; trackBy: trackContentChunkByFn"
               class="scroll-item">
            <div class="column">
              <div *ngFor="let item of column; let i = index; trackBy: trackContentByFn"
                   class="card-wrap"
                   (click)="onOpenCard(item)">
                <app-content-card-mini [item]="item"
                                       [active]="i === openedCardIndex"
                                       [linkEnable]="false"
                                       [format]="paneFormat">
                </app-content-card-mini>
              </div>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </ng-template>

    <ng-template #responsiveScroll>
      <div class="responsive-scroll-viewport" [class.mobile-content]="deviceService.isMobile()">
        <div *ngFor="let item of items; let i = index; trackBy: trackContentByFn" class="scroll-item"
             (click)="onOpenCard(item)">
          <app-content-card-mini [item]="item"
                                 [active]="i === openedCardIndex"
                                 [linkEnable]="false"
                                 [format]="paneFormat">
          </app-content-card-mini>
        </div>
      </div>
    </ng-template>
  </ng-template>

  <app-modal *ngIf="!isSmallScreen && showModal"
             [canClose]="false"
             (closed)="onCloseModal($event)"
             [prevNext]="true"
             [reachedPrev]="reachedPrev"
             [reachedNext]="reachedNext"
             (togglePrev)="togglePrev($event)"
             (toggleNext)="toggleNext($event)">
    <app-modal-body>
      <app-content-card
        class="modal"
        [item_id]="item.id"
        [show]="openedCardIndex !== null"
        [canClose]="false"
        [inline]="false"
        [active]="false"
        [meta]="true"
        (close)="onCloseCard()">
      </app-content-card>
    </app-modal-body>
  </app-modal>

  <app-mobile-modal *ngIf="isSmallScreen && showModal" (closed)="onCloseModal($event)">
    <app-mobile-modal-body>
      <div class="card">
        <app-content-card [item_id]="item.id"
                          [show]="openedCardIndex !== null"
                          [canClose]="false"
                          [inline]="false"
                          [active]="false"
                          [displayMode]="'content_page'"
                          [meta]="true"
                          (close)="onCloseCard()">
        </app-content-card>
      </div>
    </app-mobile-modal-body>

    <app-mobile-modal-actions></app-mobile-modal-actions>
  </app-mobile-modal>
</div>
